import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableSortLabel,
  Typography,
} from "@mui/material";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useScopes } from "../../../../../../STOperationhooks/useScopes";

interface BulkActionModalProps {
  open: boolean;
  onClose: () => void;
}

const BulkActionThird = ({ open, onClose }: BulkActionModalProps) => {
  const { removeNegativeSearchTerm } = useScopes();
  const {
    selectedRowsForNegativesCampaign,
    singleRowIDPassToModalForCampaign,
    // removeNegativeLoadingCampaignLoading,
  } = useSelector((state: any) => state.searchTermOperation);
  const records = useMemo(() => {
    if (!selectedRowsForNegativesCampaign) return [];
    return singleRowIDPassToModalForCampaign
      ? selectedRowsForNegativesCampaign.filter(
          (row: any) => row.id === singleRowIDPassToModalForCampaign
        )
      : selectedRowsForNegativesCampaign;
  }, [selectedRowsForNegativesCampaign, singleRowIDPassToModalForCampaign]);

  // 🔹 Grouped data according to campaign_id and total count(search term)
  const { groupedDataByCampaign, totalRemovedCount } = useMemo(() => {
    const grouped = Object.values(
      (records || []).reduce((acc: any, row: any) => {
        if (!acc[row.campaign_id]) {
          acc[row.campaign_id] = {
            campaign_id: row.campaign_id,
            campaign_name: row.campaign_name, // keep the name
            removedCount: 0,
            search_terms: [],
          };
        }

        acc[row.campaign_id].removedCount += 1;
        acc[row.campaign_id].search_terms.push(row.search_term);
        return acc;
      }, {} as Record<string, any>)
    );

    if (grouped.length === 0) {
      // handle empty case here
      return {
        groupedDataByCampaign: [],
        totalRemovedCount: 0,
        totalCampaign: 0,
      };
    }

    const total = grouped.reduce(
      (sum: number, group: any) => sum + group.removedCount,
      0
    ); // total removed count(Search Terms)
    const totalCampaign = grouped.length; // total campaign

    return {
      groupedDataByCampaign: grouped,
      totalRemovedCount: total,
      totalCampaign: totalCampaign,
    };
  }, [records]);

  // close modal and clear selected rows and single row id
  const handleCloseNegativeModalThird = () => {
    onClose();
  };

  // remove negative terms from adgroups
  const removedNegativeTermsFromCampaign = async () => {
    const sharedUids = records?.map((item: any) => item.shared_uid) || [];
    if (sharedUids.length === 0) return;
    const reqBody = {
      terms: sharedUids.map((uid: string) => ({
        shared_uid: uid,
        keep_in_ad_groups: false,
      })),
    };

    removeNegativeSearchTerm(
      reqBody,
      handleCloseNegativeModalThird,
      "campaigns"
    );
  };
  return (
    <Dialog
      open={open}
      onClose={handleCloseNegativeModalThird}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        Total Number of Search Terms Removed from Campaign: {totalRemovedCount}
      </DialogTitle>
      <DialogContent sx={{ padding: "0px 20px 16px" }}>
        {/* {removeNegativeLoadingCampaignLoading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255,255,255,0.9)",
              backdropFilter: "blur(3px)", //blur effect
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1300, // ensure it sits above modal content
            }}
          >
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              gap={2}
            >
              <CircularProgress color="secondary" size={40} />
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 500,
                  fontSize: "0.9rem",
                  lineHeight: 1.5,
                }}
              >
                Processing removal of negative search terms.
                <br />
                <Typography
                  component="span"
                  sx={{
                    fontSize: "0.85rem",
                    opacity: 0.8,
                    fontWeight: 400,
                  }}
                >
                  This may take some time, please wait...
                </Typography>
              </Typography>
            </Box>
          </Box>
        )} */}
        <Typography>Removed</Typography>
        <TableContainer component={Paper} elevation={0}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <TableSortLabel>Campaign Name</TableSortLabel>
                </TableCell>
                <TableCell align="left">
                  <TableSortLabel>
                    {totalRemovedCount} of Search Terms Removed from Campaign
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {groupedDataByCampaign.map((row: any, index) => (
                <TableRow key={index}>
                  <TableCell>{row.campaign_name}</TableCell>
                  <TableCell align="left">{row.removedCount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions sx={{ padding: "0px 16px 20px 16px" }}>
        <Button
          onClick={handleCloseNegativeModalThird}
          color="secondary"
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          data-tracker="508"
          onClick={removedNegativeTermsFromCampaign}
          color="secondary"
          variant="contained"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkActionThird;
